import { Component, OnInit } from '@angular/core';
import { Moderation } from 'src/app/classes/moderation';

@Component({
  selector: 'app-tableau',
  templateUrl: './tableau.component.html',
  styleUrls: ['./tableau.component.css']
})
export class TableauComponent implements OnInit {
  contentCol: any[];
  contents: Moderation[];

  constructor() { }

  ngOnInit(): void {
  }

}
